export default function Contact() {

    return (
        <div className="contact" id="contact">
            <h2 className="color contact_tag">Connect with me!</h2>
            <div className="contact_items">
                <a href="https://www.linkedin.com/in/kashishgoyal905/" target="blank"><img width="150" height="150" src="https://img.icons8.com/3d-fluency/375/linkedin.png" alt="linkedin" /></a>
                <a href="https://twitter.com/KashishGoyal905" target="blank"><img width="150" height="150" src="https://img.icons8.com/3d-fluency/375/twitter-circled.png" alt="twitter-circled" /></a>
                <a href="mailto:kashishgoyal961@gmail.com" target="blank"><img width="150" height="150" src="https://img.icons8.com/3d-fluency/375/gmail.png" alt="gmail" /></a>
                <a href="https://github.com/KashishGoyal905" target="blank"><img width="150" height="150" src="https://img.icons8.com/3d-fluency/375/github.png" alt="github" /></a>
            </div>
        </div>
    )
}